import { Route } from 'react-router-dom';
import { Confirmation } from 'plantItemNew/pages/paymentCallback/Confirmation';
import { Fees } from 'plantItemNew/pages/fees/Fees';
import { RelatedItemDetails } from 'plantItemNew/pages/plantItemDetails/relatedItemDetails/RelatedItemDetails';
import { AssociatedDesignRegistration } from 'plantItemNew/pages/plantItemDetails/AssociatedDesignRegistration';
import { PlantItemDetails } from 'plantItemNew/pages/plantItemDetails/PlantItemDetails';
import { PlantItemList } from 'plantItemNew/pages/plantItemDetails/PlantItemList';
import { ResumeApplication } from 'shared/pages/resumeApplication/ResumeApplication';
import { ItemRegistrationHolder } from 'plantItemNew/pages/holderDetails/itemRegistrationHolder';
import { PageLayout } from 'layouts/PageLayout';
import React from 'react';
import { PagePath } from 'shared/constants/pagePath';
import { PrivateRoute } from 'shared/components/privateRoute/PrivateRoute';
import { PlantItemConstants } from 'plantItemNew/constants/plantItemConstants';
import { PlantItemNewResetApplication } from 'plantItemNew/components/resetApplication/PlantItemNewResetApplication';
import { PlantItemNewDeclaration } from 'plantItemNew/pages/declaration/PlantItemNewDeclaration';
import { InvalidApplicationError } from 'shared/pages/resumeApplication/InvalidApplicationError';

const PlantItemNewRoutes = (props) => {
  const pageLayoutLabel = 'Plant item registration';

  return (
    <>
      <Route path={PagePath.plantItemNewRoot} element={<PlantItemNewResetApplication />} />

      <Route
        path={PagePath.holderDetails}
        element={
          <PrivateRoute storeCurrentPath>
            <PageLayout title="Registration holder" label={pageLayoutLabel}>
              <ItemRegistrationHolder />
            </PageLayout>
          </PrivateRoute>
        }
      />

      <Route
        path={PagePath.applicationById}
        element={
          <PrivateRoute storeRedirect>
            <PageLayout>
              <ResumeApplication {...props} licenceType={PlantItemConstants.licenceType} />
            </PageLayout>
          </PrivateRoute>
        }
      />

      <Route
        path={PagePath.plantItemList}
        element={
          <PrivateRoute storeCurrentPath>
            <PageLayout title="Plant item details" label={pageLayoutLabel}>
              <PlantItemList {...props} />
            </PageLayout>
          </PrivateRoute>
        }
      />
      <Route
        path={`${PagePath.plantDetails}/:index`}
        element={
          <PrivateRoute storeCurrentPath>
            <PageLayout title="Add a plant item" label={pageLayoutLabel}>
              <PlantItemDetails {...props} />
            </PageLayout>
          </PrivateRoute>
        }
      />
      <Route
        path={`${PagePath.associatedDesign}/:index`}
        element={
          <PrivateRoute storeCurrentPath>
            <PageLayout title="Associated design registration" label={pageLayoutLabel}>
              <AssociatedDesignRegistration {...props} />
            </PageLayout>
          </PrivateRoute>
        }
      />

      <Route
        path={`${PagePath.relatedItemDetails}/:index`}
        element={
          <PrivateRoute storeCurrentPath>
            <PageLayout title="Add a plant item" label={pageLayoutLabel}>
              <RelatedItemDetails {...props} />
            </PageLayout>
          </PrivateRoute>
        }
      />

      <Route
        path={PagePath.fees}
        element={
          <PrivateRoute storeCurrentPath>
            <PageLayout title="Fees" label={pageLayoutLabel}>
              <Fees {...props} />
            </PageLayout>
          </PrivateRoute>
        }
      />

      <Route
        path={PagePath.confirmation}
        element={
          <PrivateRoute storeRedirect>
            <PageLayout title="Confirmation" label={pageLayoutLabel}>
              <Confirmation {...props} />
            </PageLayout>
          </PrivateRoute>
        }
      />

      <Route
        path={PagePath.declaration}
        element={
          <PrivateRoute storeCurrentPath>
            <PageLayout title="Declaration" label={pageLayoutLabel}>
              <PlantItemNewDeclaration {...props} />
            </PageLayout>
          </PrivateRoute>
        }
      />

      {/* Navigate to the error page if old resume-application-link was used */}
      <Route
        path="/application/:id"
        element={
          <PageLayout>
            <InvalidApplicationError {...props} licenceType={PlantItemConstants.licenceType} />
          </PageLayout>
        }
      />
    </>
  );
};

export default PlantItemNewRoutes;
